"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModal = void 0;
var React = __importStar(require("react"));
var Modal_1 = require("../componentes/Modal");
function useModal(conteudoDaModal, propriedadesDaModal) {
  var _a = React.useState(false),
    isShowingModal = _a[0],
    setIsShowingModal = _a[1];
  var mostrar = React.useCallback(function () {
    return setIsShowingModal(true);
  }, []);
  var esconder = React.useCallback(function () {
    setIsShowingModal(false);
  }, []);
  var injectedPropsElement = React.cloneElement(conteudoDaModal, {
    metodosDaModal: {
      esconder: esconder,
      mostrar: mostrar
    }
  });
  var elementoComPropriedadesDaModal = React.useMemo(function () {
    return isShowingModal && React.createElement(Modal_1.Modal, __assign({
      aoFechar: esconder
    }, propriedadesDaModal), injectedPropsElement);
  }, [isShowingModal, injectedPropsElement]);
  return [elementoComPropriedadesDaModal, mostrar, esconder];
}
exports.useModal = useModal;